import React from 'react'
import { BasePage } from './BasePage'
import { Details } from './Details'

export const DetailsPage = ({ match }) => {
  return (
    <React.Fragment>
      <BasePage
        Comp={() =>
          Details({
            orderId: match.params.orderId,
            coursenum: match.params.coursenum,
          })
        }
      />
    </React.Fragment>
  )
}
